module.exports = __webpack_public_path__ + "img/1513845846.31907d70.jpg";